import React, { useState, useEffect } from 'react';
import axios from 'axios';
import constraints from '../constraints';

export default function DirectPurchaseSuccess() {
  useEffect(() => {
    async function init() {
      // get params
      const params = new URLSearchParams(window.location.search);
      const orderId = params.get('orderId');
      const amount = params.get('amount');
      const paymentKey = params.get('paymentKey');

      // send request to server
      const response = await axios.post(constraints.config.API_URL + '/purchase/direct', {
        orderId,
        amount,
        paymentKey
      });

      if (response.status >= 200) {
        alert(`결제가 완료되었습니다. 카카오톡 프로필 조회를 시작합니다.`);
        //window.open(`https://www.kakaotracker.com/profile?taskId=${response.data.taskId}`, '_blank');
        window.location.replace(`https://www.kakaotracker.com/profile?taskId=${response.data.taskId}`);
      }
    }

    init();
    
  }, []);

  return null;
}